import React from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import { HealthAndSafety, MedicalInformation } from '@mui/icons-material'
import { useAppData } from '../../../../context/AppDataContext'
import associateProfileServices from '../associateProfileServices';

function ChooseRolePage() {

  const {getAssociateProfile} = useAppData();

  const updateRole = (inputValue) =>{
    const payload = {
        role: inputValue
    }
    associateProfileServices.save(payload).then(res=>{
        console.log(res.data);
        getAssociateProfile();
    }).catch(error=>{
        console.log(error);
    })
  }

  return (
    <AppLayout>
      <div className='container'>
        <div className="alert alert-info" role="alert">
          Select Your Role to continue
        </div>
        <div className='row text-center'>
          <div className='col-md-6'>
            <button className='btn btn-lg btn-success' onClick={(()=>updateRole(11))} ><MedicalInformation/> I am a Doctor</button>
          </div>
          <div className='col-md-6'>
            <button className='btn btn-lg btn-primary' onClick={()=>updateRole(12)} ><HealthAndSafety/> I am a clinic Staff</button>
          </div>
        </div>
      </div>
    </AppLayout>
    
  )
}

export default ChooseRolePage